export default {
  // Page title
  'adsMccAccount.title': 'MCC Account Settings',

  // Search fields
  'adsMccAccount.platform': 'Ad Platform',
  'adsMccAccount.mccName': 'MCC Name',

  // Buttons
  'adsMccAccount.search': 'Search',
  'adsMccAccount.reset': 'Reset',
  'adsMccAccount.add': 'Add',
  'adsMccAccount.delete': 'Delete',

  // Table columns
  'adsMccAccount.serial': 'Serial',
  'adsMccAccount.apiToken': 'API Developer Token',
  'adsMccAccount.clientId': 'OAuth Client ID',
  'adsMccAccount.clientSecret': 'OAuth Client Secret',
  'adsMccAccount.refreshToken': 'Refresh Token',
  'adsMccAccount.authStatus': 'Auth Status',
  'adsMccAccount.action': 'Action',

  // Auth status
  'adsMccAccount.authorized': 'Authorized',
  'adsMccAccount.unauthorized': 'Unauthorized',

  // Form validation
  'adsMccAccount.platformRequired': 'Please select ad platform',
  'adsMccAccount.mccNameRequired': 'Please enter MCC name',
  'adsMccAccount.refreshTokenRequired': 'Please enter Refresh Token',

  // Form placeholders
  'adsMccAccount.mccNamePlaceholder': 'Custom MCC name',
  'adsMccAccount.apiTokenRequired': 'Please enter API developer token',
  'adsMccAccount.clientIdRequired': 'Please enter OAuth Client ID',
  'adsMccAccount.clientSecretRequired': 'Please enter OAuth Client Secret',
  'adsMccAccount.refreshTokenPlaceholder': 'Please click the button below to get',
  'adsMccAccount.getRefreshToken': 'Get Refresh Token',
  'adsMccAccount.getRefreshTokenInfo': 'Getting refresh token...',
  'adsMccAccount.validationError': 'Please fill in all required fields',
  'adsMccAccount.save': 'Save',
  'adsMccAccount.cancel': 'Cancel',
  'adsMccAccount.fetchDataFailed': 'Failed to fetch data',
  'adsMccAccount.fetchTypesFailed': 'Failed to fetch ad platform types',
  'adsMccAccount.noData': 'No data',

  // Modal title
  'adsMccAccount.addMccAccount': 'Add MCC Account',

  // Messages
  'adsMccAccount.addSuccess': 'Added successfully',
  'adsMccAccount.addFailed': 'Add failed',
  'adsMccAccount.deleteSuccess': 'Deleted successfully',
  'adsMccAccount.deleteFailed': 'Delete failed',
  'adsMccAccount.confirmDelete': 'Are you sure to delete this record?',

  // Pagination
  'adsMccAccount.totalRecords': 'Total {total} records',
  'adsMccAccount.pagination': 'Page {current} of {page}, Total {total} records',
};
